// src/main.jsx
import React from "react";
import ReactDOM from "react-dom/client";
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.jsx"; // App will be the root element for most paths
import "./index.css";
import "leaflet/dist/leaflet.css"; // If you use Leaflet directly
// mapbox-gl.css is usually imported in index.css or where mapbox is used

// No need to import individual page components here if App.jsx handles their routing internally.

const router = createBrowserRouter([
  {
    // This will match all paths and render the App component.
    // App.jsx will then use its internal <Routes> to determine
    // whether to show LoginScreen (if not authenticated) or
    // the main application content (if authenticated).
    path: "/*", // Use "/*" to make App the handler for all routes
    element: <App />,
  }
  // You could add other top-level routes here if they truly exist
  // outside the App component's structure (e.g., a dedicated /admin route
  // with a completely different layout). But for your current setup,
  // App seems to be the main controller.
]);

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <HelmetProvider>
      <RouterProvider router={router} />
    </HelmetProvider>
  </React.StrictMode>
);